import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CaptchaInputModule } from '../captcha-input/captcha-input.module';
import { DonorModule } from '../donor/donor.module';
import { FrCardModule } from '../fr-card/fr-card.module';
import { PlaceholderLoaderModule } from '../placeholder-loader/placeholder-loader.module';
import { StartSupportingFrComponent } from './components/start-supporting-fr/start-supporting-fr.component';
import { SupportingFrCardComponent } from './components/supporting-fr-card/supporting-fr-card.component';
import { SupportingFrLiveComponent } from './components/supporting-fr-live/supporting-fr-live.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CurrencyDropdownModule } from '../currency-dropdown/currency-dropdown.module';
import { FbLoginModule } from '../fb-login/fb-login.module';
import { SharedModule } from '../../shared/shared.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FrCardModule,
    DonorModule,
    PlaceholderLoaderModule,
    CaptchaInputModule,
    CurrencyDropdownModule,
    FbLoginModule,
    SharedModule,
    ModuleLoaderModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  declarations: [
    SupportingFrCardComponent,
    StartSupportingFrComponent,
    SupportingFrLiveComponent
  ],
  exports: [
    SupportingFrCardComponent,
    StartSupportingFrComponent,
    SupportingFrLiveComponent
  ]
})
export class SupportingFrModule { }
